import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-rate/es/index.js
// module id = 1428
// module chunks = 0